<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span class="bid_item_title">普通公告</span>
      <el-button @click="moreRecord" class="bid_more" type="text">
        更多
        <i class="el-icon-arrow-right el-icon--right"></i>
      </el-button>
    </div>
    <div
      v-for="(rItem,index) in recordArr"
      :key="index"
      class="bid_note_item"
      @click="seeRecord(rItem.bidsId)"
    >
      <el-row>
        <el-col :span="20">
          <span class="bid_common_item">{{rItem.bidsName}}</span>
        </el-col>
        <el-col :span="4">{{rItem.promTime}}</el-col>
      </el-row>
    </div>
  </el-card>
</template>
<script>
import { bidList } from '@/api/frontApi/bidding';
export default {
  data() {
    return {
      recordArr: []
    };
  },
  created() {
    this.initOrdinaryData(1, 7);
  },
  methods: {
    initOrdinaryData(pageNo, pageSize) {
      bidList(pageNo, pageSize, 0).then(res => {
        this.recordArr = [];
        this.recordArr = res.data.list;
      });
    },
    moreRecord() {
      this.$emit('sendBack', 4);
      this.initOrdinaryData(1, 100);
    },
    seeRecord(bidsId) {
      if (bidsId) {
        this.$router.push({
          name: 'biddingInfo',
          params: {
            bidId: bidsId,
            itemNmae: '普通公告'
          }
        });
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.bid_note_item {
  height: 28px;
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/bidding/ordinaryNotice.vue